import * as React from "react";

const YoutubeIcon: React.FC = () => {
    return (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M22.7678 19.1706L18.2032 17.0408C17.8049 16.8558 17.4777 17.0631 17.4777 17.5041V21.5159C17.4777 21.9569 17.8049 22.1642 18.2032 21.9792L22.7657 19.8494C23.1661 19.6624 23.1661 19.3576 22.7678 19.1706ZM19.51 0C8.73479 0 0 8.73479 0 19.51C0 30.2852 8.73479 39.02 19.51 39.02C30.2852 39.02 39.02 30.2852 39.02 19.51C39.02 8.73479 30.2852 0 19.51 0ZM19.51 27.4359C9.52332 27.4359 9.34854 26.5356 9.34854 19.51C9.34854 12.4844 9.52332 11.5841 19.51 11.5841C29.4967 11.5841 29.6715 12.4844 29.6715 19.51C29.6715 26.5356 29.4967 27.4359 19.51 27.4359Z"
                fill="white"
            />
        </svg>
    );
};

export default React.memo(YoutubeIcon);
